var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9289 1.73387C13.8547 1.07901 13.2719 0.451057 12.6619 0.366925C8.94297 -0.122308 5.18221 -0.122308 1.46437 0.366925C0.853975 0.450872 0.271062 1.07901 0.196912 1.73387C-0.0656375 4.13391 -0.0656375 6.46096 0.196912 8.86044C0.271062 9.5153 0.853975 10.1438 1.46437 10.2274C5.18221 10.7167 8.94309 10.7167 12.6619 10.2274C13.2719 10.1441 13.8547 9.5153 13.9289 8.86044C14.1915 6.46122 14.1915 4.13391 13.9289 1.73387ZM5.88568 7.79015V2.80485L9.41716 5.2977L5.88568 7.79015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeImg);
export default __webpack_public_path__ + "static/media/youtube-img.fc16ec1a8eae3f7ae150d09c3e15bcb1.svg";
export { ForwardRef as ReactComponent };